import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

/** Maps legacy snake_case tab values to kebab-case route segments */
const OPS_INBOX_TAB_MAP: Record<string, string> = {
  'all': 'all',
  'exception': 'exceptions',
  'approval': 'approvals',
  'failed_operation': 'failed-operations',
  'custom_slot_approval': 'custom-slot-approvals',
  'ai_action_review': 'ai-action-reviews',
}

const legacySearchSchema = z.object({
  tab: z.string().optional(),
}).passthrough()

export const Route = createFileRoute('/_authenticated/ops-inbox/')({
  validateSearch: legacySearchSchema,
  beforeLoad: ({ search }) => {
    const { tab, ...rest } = search as Record<string, unknown>
    const raw = typeof tab === 'string' && tab ? tab : 'all'
    const segment = OPS_INBOX_TAB_MAP[raw] ?? 'all'
    throw redirect({
      to: `/ops-inbox/${segment}`,
      search: rest as Record<string, string>,
    })
  },
})
